import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getAllPlans () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'plan/information',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getPlanStatus () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'plan/status',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updatePlanBySales (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Plan/selfSalesUpdate',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getMyPlan () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'listing/information',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCheckoutSession (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'memberPlan/create-checkout-session-credit',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCheckoutSessionMulti (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'memberPlan/create-checkout-session-multi',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/planservice.js